
window.__lazy_callback__ = function (lazyModule) {
  return class extends React.Component {
    state = {
      component: null,
    }
    componentWillMount() {
      lazyModule((module) => {
        if (typeof module.default === 'function') {
          this.setState({
            component: module.default,
          });
        } else {
          this.setState({
            component: module,
          });
        }
      });
    }
    render() {
      const Comp = this.state.component;
      return Comp ? <Comp {...this.props} /> : <div />;
    }
  };
}

import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux'
import { setloginType, setLoadingPop } from '../../store/common/action'
import { withRouter } from 'react-router-dom';
import USER_API from '../../api/user'

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({
  setloginType: value => {
    dispatch(setloginType(value))
  },
  setLoadingPop: value => {
    dispatch(setLoadingPop(value))
  }
})

class UserInfor extends Component {
  componentWillMount() {
    this.getUserInfor()
  }
  getUserInfor = async () => {
    this.props.setLoadingPop(true)
    try {
      const result = await USER_API.getUserInfor()
      this.props.setLoadingPop(false)
      if (result.data.code === 0) {
        const user = result.data.data.user
        localStorage.setItem('uid', user.uid)
        // console.log(user)
      } else {
        if (result.data.code === 10111) {
          document.cookie = `utoken=;domain=.makeblock.com;path=/`
          this.props.setloginType(false)
          this.props.history.push('/')
        }
      }
      return result
    } catch (error) {
      this.props.setLoadingPop(false)
      console.log(error)
    }
  }
  render() {
    return(
      <Fragment />
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserInfor))